import React, { useState, useEffect, useMemo } from "react";
import { database } from "../../database/firebase";
import { Header } from "../../components";
import Table, { SelectColumnFilter, StatusPill } from "../../components/Table";

function FisherRecord() {

  const [fisherDataRes, setfisherDataRes] = useState([]);
  const [fisherCell, setfisherCell] = useState([]);
  const [uUid, setuUid] = useState("");
  const [fisherId, setFisherId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  useEffect(() => {
    // console.log("Fisher");
    //basically if array is undefined, do not render in DOM
    const fetchFisher = async () => {

      let uid = localStorage.getItem("uid");
      let userUid = JSON.parse(uid);
      setuUid(userUid);
      //Get fisher records
      database.child(`users/${userUid}/userfisher`).once("value", (snap) => {
        const fisher = snap.val();
        setfisherCell([fisher]);

        for (var key in fisher) {
          setfisherDataRes(prevArray => [...prevArray, fisher[key]])
        }
      });
    };
    fetchFisher();
  }, []);

  const showCard = (val) => {
    setShowModal(true);
    setFisherId(val);

  };

  const showDelete = () => {
    setDeleteModal(true);
  }

  const cancelDelete = () => {
    setDeleteModal(false);

  }

  // const exportData = () => {
  //   if (localStorage.getItem('role') === "master" ||
  //     localStorage.getItem('role') === "developer" ||
  //     localStorage.getItem('role') === "superadmin"
  //   ) {
  //     exportFromJSON({
  //       data: fisherDataRes,
  //       fileName: 'fishermenrecord',
  //       exportType: 'csv'
  //     });
  //   } else {
  //     alert("Unauthorized access.")
  //   }
  // }


  const downloadQR = (fQR, fFN, fLN) => {
    let downloadLink = document.createElement("a");
    downloadLink.href = fQR;
    downloadLink.download = fLN + '_' + fFN + fQR + '.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const deleteFisher = (fUid) => {

    database.child(`users/${uUid}/userfisher/${fUid}`)
      .remove()
      .then(() => {
        console.log('Record deleted.');
      })
      .catch((error) => {
        console.log('error rtd', error);
      });
    // console.log(fUid);


    // auth
    // .getUser(uid)
    // .then((userRecord) => {
    //   // See the UserRecord reference doc for the contents of userRecord.
    //   console.log(`Successfully fetched user data: ${userRecord.toJSON()}`);
    // })
    // .catch((error) => {
    //   console.log('Error fetching user data:', error);
    // });
    // firebase.auth()
    //   .delete(fUid)
    //   .then(() => {
    //    alert('Successfully deleted user.');
    //   })
    //   .catch((error) => {
    //     alert('Error deleting user:', error);
    //   });

    setShowModal(false);
  }

  const columns = useMemo(
    () => [
      {
        Header: "Last Name",
        accessor: "lastName",

      },
      {
        Header: "First Name",
        accessor: "firstName",
      },

      {
        Header: "Vessel",
        accessor: "vesselNum",
      },
      {
        Header: "Origin",
        accessor: "regOrigin",
        id: "origin", //added this
        Filter: SelectColumnFilter,  // new
        filter: 'includes',  // new
      },
      {
        Header: "Mobile",
        accessor: "mobileNum",
      },
      {
        Header: "Status",
        accessor: "regStatus",
        Cell: StatusPill
      },
      {
        Header: "Action",
        accessor: "fisherUid",
        Cell: ({ cell }) => (
          <button value={cell.value}
            className=" w-full bg-blue-600 text-white text-sm font-regular py-1 px-6 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
            onClick={e => showCard(e.target.value)}>
            View
          </button>
        )
      },


    ],
    []
  );


  const data = useMemo(() => fisherDataRes);
  //here just straight get the state array

  return (
    <>
      <div className="md:flex">
        <aside class="md:h-screen md:sticky md:top-0">
          <Header />
        </aside>

        <div className="flex flex-col">
          <div className="flex w-full justify-between h-14  mt-20 ml-5">
            <div className="text-4xl mb-10 text-blue-700 font-sans font-bold">
              Fisherman Records
            </div>
          
          </div>

          {showModal ? (
            <>
              <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
              >
                <div className="relative w-auto my-6 mx-auto max-w-max">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                      <p className="text-medium  font-normal pr-10 text-black-900">
                        Fisher ID: {fisherId}
                      </p>

                      <button
                        className="p-1 ml-auto  border-0 text-black-900 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setShowModal(false)}
                      >
                        <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                          ×
                        </span>
                      </button>
                    </div>
                    {/*body*/}
                    <div className="sm:flex justify-between">

                      <div className="p-5 mx-5">

                        <p className="text-lg text-gray-500 font-sans font-normal">
                          Name</p>
                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                          {fisherCell['0'][fisherId].lastName}, {fisherCell['0'][fisherId].firstName}</p>
                        <p className="text-lg text-gray-500 font-sans font-normal">
                          Vessel No.</p>
                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                          {fisherCell['0'][fisherId].vesselNum}</p>
                        <p className="text-lg text-gray-500 font-sans font-normal">
                          Contact No.</p>

                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                          {fisherCell['0'][fisherId].mobileNum}</p>

                      </div>
                      <div className="p-5 mx-5">


                        <p className="text-lg text-gray-500 font-sans font-normal">
                          Origin of Registration</p>
                        <p className="text-2xl pb-5  text-gray-500 font-sans font-extrabold">
                          {fisherCell['0'][fisherId].regOrigin}</p>
                        <p className="text-lg text-gray-500 font-sans font-normal">
                          Type of Gear</p>
                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                          {fisherCell['0'][fisherId].fishGear}</p>

                        {/* <p className="text-lg text-gray-500 font-sans font-normal">
                        Username</p>
                      <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                        {fisherCell['0'][fisherId].username}</p>
                    */}
                      </div>



                    </div>
                    {deleteModal ? (
                      <>
                        <div className="flex mx-6 align-horizontally">
                          <p>
                            Delete this account?
                          </p>

                          <button
                            className="bg-red-600 text-white active:bg-emerald-600 font-normal uppercase text-sm px-6 py-1 mx-2 rounded hover:bg-yellow-500  mr-1 mb-1"
                            type="button"
                            onClick={() => deleteFisher(fisherId)}
                          >
                            Confirm
                          </button>
                          <button
                            className="bg-blue-600 text-white active:bg-emerald-600 font-normal uppercase text-sm px-6 py-1 mx-2 rounded hover:bg-yellow-500  mr-1 mb-1"
                            type="button"
                            onClick={cancelDelete}
                          >
                            Cancel
                          </button>
                        </div>

                      </>
                    ) : null}
                    {/*footer*/}
                    <div className="flex items-center justify-between p-6 border-t border-solid border-blueGray-200 rounded-b">

                      <button
                        className="border-red-600 border-2 text-red-600 active:bg-emerald-600 font-normal uppercase text-sm px-6 py-3 rounded hover:bg-red-100  mr-1 mb-1"
                        // className="border-2 border-purple-500 hover:border-gray-500"
                        type="button"
                        onClick={showDelete}
                      >
                        Delete
                      </button>
                      {/* <button
                        className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </button> */}
                      <button
                        className="bg-blue-600 text-white active:bg-emerald-600 font-normal uppercase text-sm px-6 py-3 rounded  hover:bg-yellow-400 outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                        onClick={() => downloadQR(fisherCell['0'][fisherId].fisherQR, fisherCell['0'][fisherId].firstName, fisherCell['0'][fisherId].lastName)}
                      >
                        Download QR Code
                      </button>

                    </div>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}
          <div className="flex">
            <div className="max-width m-auto p-5  text-gray-900" >
              <div className="rounded-xl bg-white shadow-2xl sm:p-10">
                {fisherDataRes == [] ?
                  <div>Loading...</div>
                  :
                  <Table
                    columns={columns}
                    data={data}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default FisherRecord;